import BaseService from './BaseService';
import entities from 'src/config/entities'

class SearchSuggestionsService extends BaseService {

  constructor () {
    super({entity: entities.SUGGESTION})
  }
}

export default new SearchSuggestionsService()
